// Rarities that turn water ponds into lava
const LAVA_MOD_RARITIES = new Set(['rare', 'epic', 'legendary']);

/**
 * Renders pond terrain hazards.
 * Rendered BELOW the player so the player sprite walks on top of ponds.
 * Props: ponds, env (environment name), activeModifierRarity
 */
export function PondLayer({ ponds, env, activeModifierRarity }) {
  if (!ponds?.length) return null;
  const isLava = LAVA_MOD_RARITIES.has(activeModifierRarity);
  return ponds.map(pond => (
    <div
      key={pond.id}
      className={`pond ${isLava ? 'pond--lava' : `pond--env-${env}`}`}
      style={{ transform: `translate3d(${pond.x}px,${pond.y}px,0)`, width: pond.size, height: pond.size }}
    />
  ));
}
